import { EVENT_PAYLOAD } from '#pplx/frontend/framework/instrumentation/types.js';
export const homepageSearchModeSelectedEvent = EVENT_PAYLOAD;
export const homepageComputerProjectSelectorClickedEvent = EVENT_PAYLOAD;
export const computerProjectPickerSearchChangedEvent = EVENT_PAYLOAD;
export const homepageComputerConnectorLauncherClickedEvent = EVENT_PAYLOAD;
//# sourceMappingURL=analytics.js.map